import { useRef } from 'react';

export function useRetryingAnimationRunner() {
  const runningAnimationRef = useRef<any>(null);
  const runningAnimationStartTimestampRef = useRef<number | null>(null);
  const runningAnimationDurationRef = useRef<number | null>(null);

  // just keep the same runner, no dependencies needed
  return useRef(
    (animate, { animationDuration = 0, replaceRunningAnimation = true }) => {
      const animationReturnValue = animate(animationDuration);

      if (replaceRunningAnimation) {
        runningAnimationRef.current = animate;
        runningAnimationStartTimestampRef.current = Date.now();
        runningAnimationDurationRef.current = animationDuration;
      } else if (
        runningAnimationRef.current &&
        runningAnimationStartTimestampRef.current &&
        runningAnimationDurationRef.current &&
        Date.now() - runningAnimationStartTimestampRef.current <
          runningAnimationDurationRef.current
      ) {
        runningAnimationRef.current(
          runningAnimationDurationRef.current -
            (Date.now() - runningAnimationStartTimestampRef.current),
        );
      }

      return animationReturnValue;
    },
  ).current;
}
